export default __webpack_public_path__ + "static/media/user.fd5188b9.svg";